// Case report comparison helpers — extracted from legacy-utils.ts

import { hasValue } from './validation';
import { deepCopyProperties } from './arrays';

export function isCaseReportEqual(reportOriginal: any, reportCurrent: any): boolean {
  const reportOriginalCopy: any = deepCopyProperties(reportOriginal);
  const reportCurrentCopy: any = deepCopyProperties(reportCurrent);
  for (let reportCopy of [reportOriginalCopy, reportCurrentCopy]) {
    delete reportCopy.availableOfficers;
    delete reportCopy.officerLabel;
    delete reportCopy.officerPluralLabel;

    delete reportCopy.narrativeContent;
    delete reportCopy.isNarrativeReadOnly;
    delete reportCopy.narrativeToolbarConfig;
    delete reportCopy.reportId;

    delete reportCopy.currentTheme;
    delete reportCopy.isReadOnly;

    delete reportCopy.activeTab;
    delete reportCopy.visibleTabIds;
    delete reportCopy.showMoreMenu;
    delete reportCopy.allTabIds;

    delete reportCopy.showAddPropertyModal;
    delete reportCopy.showAddPatientModal;
    delete reportCopy.showAddStatementModal;
    delete reportCopy.showAddEvidenceModal;
    delete reportCopy.showAddAccidentPersonModal;
    delete reportCopy.showAddOffenderModal;
    delete reportCopy.showReturnToAuthorModal;
    delete reportCopy.showInvolvedSearchModal;
    delete reportCopy.involvedSearchType;
    delete reportCopy.involvedSearchAction;
    delete reportCopy.showViewPersonModal;
    delete reportCopy.viewPersonId;
    delete reportCopy.showViewVehicleModal;
    delete reportCopy.viewVehicleId;
    delete reportCopy.showViewBusinessModal;
    delete reportCopy.viewBusinessId;
    delete reportCopy.showViewClientModal;
    delete reportCopy.viewClientId;

    delete reportCopy.editingItem;
    delete reportCopy.editingAccidentPerson;
    delete reportCopy.editingStatement;
    delete reportCopy.editingEvidence;
    delete reportCopy.pendingEvidenceFiles;
    delete reportCopy.propertyForm;
    delete reportCopy.patientForm;
    delete reportCopy.statementForm;
    delete reportCopy.evidenceForm;
    delete reportCopy.accidentPersonForm;
    delete reportCopy.offenderForm;

    delete reportCopy.propertyOwnerOptions;
    delete reportCopy.reportedAsOptions;
    delete reportCopy.involvedPersonOptions;
    delete reportCopy.involvedVehicleOptions;
    delete reportCopy.ownerOptions;
    delete reportCopy.offenseOptions;
    delete reportCopy.evidenceOfOptions;
    delete reportCopy.allInvolvedOptions;
    delete reportCopy.natureOfCallOptions;

    if (hasValue(reportCopy) && hasValue(reportCopy.backupUnits) && reportCopy.backupUnits.length > 0) {
      for (let backupUnitCopy of reportCopy.backupUnits) {
        backupUnitCopy.officerName = null;
      }
    }
  }
  return JSON.stringify(reportOriginalCopy) === JSON.stringify(reportCurrentCopy);
}
